module.exports = __webpack_public_path__ + "img/undraw_2.95381a19.png";